module.exports = __webpack_public_path__ + "img/icon-warning-ice-orange.a2000c4f.svg";